import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mt-md service-agree-form" }

import { reactive } from 'vue';
import ServiceTermDialog from '../dialogs/ServiceTermDialog.vue';
import PrivacyPolicyDialog from '../dialogs/PrivacyPolicyDialog.vue';

interface Props {
  isAgreeChecked: {
    terms: boolean;
    policy: boolean;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceAgreeForm',
  props: {
    isAgreeChecked: {}
  },
  emits: ['terms', 'policy'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// チェック状態
const isAgreeChecked = reactive(props.isAgreeChecked);

// ダイアログ表示フラグ
const isDisplayDialog = reactive({
  terms: false,
  policy: false,
});

/**
 * 利用規約に同意したチェック状態を設定
 * @param {boolean} event チェック状態
 */
const setTermCheck = (event: boolean) => {
  // チェック状態に設定
  isAgreeChecked.terms = event;
  // ダイアログ非表示
  isDisplayDialog.terms = !event;
  emit('terms', true);
};

/**
 * プライバシーポリシーに同意したチェック状態を設定
 * @param {boolean} event チェック状態
 */
const setPrivacyCheck = (event: boolean) => {
  // チェック状態に設定
  isAgreeChecked.policy = event;
  // ダイアログ非表示
  isDisplayDialog.policy = !event;
  emit('policy', true);
};

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "q-mb-xs privacy-text" }, " 以下利用規約・プライバシーポリシーをお読み頂き、同意の上ご利用ください。 ", -1)),
    _createVNode(_component_q_list, {
      dense: "",
      class: "service-agree-form-checkbox-area"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, {
              side: "",
              class: "q-pr-none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_checkbox, {
                  modelValue: isAgreeChecked.terms,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAgreeChecked.terms) = $event)),
                  color: "primary",
                  disable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              dense: "",
              flat: "",
              color: "primary",
              label: "利用規約",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isDisplayDialog.terms = true))
            }),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "q-my-auto" }, "に同意する", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, {
              side: "",
              class: "q-pr-none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_checkbox, {
                  modelValue: isAgreeChecked.policy,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isAgreeChecked.policy) = $event)),
                  color: "primary",
                  disable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              dense: "",
              flat: "",
              color: "primary",
              label: "プライバシーポリシー",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isDisplayDialog.policy = true))
            }),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "q-my-auto" }, "に同意する", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ServiceTermDialog, {
      "is-disp-dialog": isDisplayDialog.terms,
      onCloseDialog: setTermCheck
    }, null, 8, ["is-disp-dialog"]),
    _createVNode(PrivacyPolicyDialog, {
      "is-disp-dialog": isDisplayDialog.policy,
      onCloseDialog: setPrivacyCheck
    }, null, 8, ["is-disp-dialog"])
  ]))
}
}

})